import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { MultiSelect } from 'primeng/multiselect';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';

import {
  AppSettingsService,
  AuthenticationService,
  BaseComponent,
  Message,
} from 'iui-iconectiv-lib';

import {
  GenericMessage,
  QueryPaging,
  SortCriteria,
} from '../shared';

import { Account, AccountCompletionService } from '../account-completion';
import { ServiceDeskService } from './servicedesk.service';
import {FeeScheduleService} from "../shared/fee-schedule";
import {BaseRua, Tier} from "../shared/model";
import { NgForm } from '@angular/forms';

declare var $: any;

class Filter {
  accountId: string;
  companyName: string;
  spid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  accountType: string;
  status: string[];

  reset() {
    this.accountId = '';
    this.companyName = '';
    this.spid = '';
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.accountType = '';
    this.status = [];
  }
}

class EditAccount {
  accountType: SelectItem = null;
  canEditAccount = false;
  showArea = false;
  canDeleteAccount = false
  reset() {
    this.accountType = null;
    this.canEditAccount = false;
    this.canDeleteAccount = false;
    this.showArea = false;
  }
}


class Status {
  currentStatus = '';
  changedStatus = '';
  canChangeStatus = false;
  showArea = false;

  reset() {
    this.currentStatus = '';
    this.changedStatus = '';
    this.canChangeStatus = false;
    this.showArea = false;
  }
}


@Component({
  selector: 'app-servicedesk',
  templateUrl: './servicedesk.component.html',
  styleUrls: ['./servicedesk.component.scss']
})
export class ServiceDeskComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChild('ptable') ptable: Table;
  @ViewChildren('ptable') aTable: QueryList<Table>;
  @ViewChild('tierFilter') tierFilter: MultiSelect;
  @ViewChild('sdForm') accountForm: NgForm;
  @ViewChild('rua') ruaDialog;
  @ViewChild('reportDialog') reportDialog;
  tableForFilters: Table;

  filter = new Filter();
  tiers: SelectItem[];
  filteredAccounts : Account[];
  accounts: Account[];
  cols: any[];
  display: boolean = false;

  selectedAccountType: SelectItem = null;
  accountTypes: SelectItem[];
  accountStatuses: SelectItem[];
  contractTypes: SelectItem[];
  agreementTypes: SelectItem[];
  // user selected account
  selectedAccount: any = {};
  selectedAccountCopy: any = {};

  selectedStatuses: string[] = [];
  isError = false;
  // user is working on the selected account
  isWorkingOnSelected = false;

  isNonStandardAccountValid = false;

  // handle of status
  editHandle: EditAccount = new EditAccount();

  // handle of status
  statusHandle: Status = new Status();

  // account table index of the first row on the current page
  first: number;

  // '# Regional User Agreement(s)' text
  //numOfRua: string = this.getRuaDisplay();

  // validator patterns:
  nameValidatorPattern = Account.nameValidatorPattern;
  phoneValidatorPattern = Account.phoneValidatorPattern;
  zipCodeValidatorPattern = Account.zipCodeValidatorPattern;
  numberValidatorPattern = Account.numberValidatorPattern;

  ACCOUNT_TYPE_STANDARD = Account.ACCOUNT_TYPE_STANDARD.value;
  ACCOUNT_TYPE_NON_STANDARD = Account.ACCOUNT_TYPE_NON_STANDARD.value;

  // truncate threshold, if the length of the host string is longer, truncation will occur
  // default is 30 characters
  truncateThreshold = 30;

  // show "Back to Top" when scrolling off the page
  showHome: boolean;

  isAccountSelected: Boolean;
  sameAsAccount: boolean = false;

  // for persistance of sort data
  sortFieldTable: any = {};

  // to prevent getFilter method of executing more than once
  wereFiltersLoaded: boolean = false;

  sticky: boolean = false;
  menuPosition: any;

  constructor(
    private accountCompletionService: AccountCompletionService,
    private appSettings: AppSettingsService,
    private authService: AuthenticationService,
    private feeScheduleService: FeeScheduleService,
    private router: Router,
    private serviceDeskService: ServiceDeskService,
    private changeDetector : ChangeDetectorRef
  ) {

    super();

    this.cols = [
      { field: 'accountId', header: 'Account ID', width: '7' },
      { field: 'accountType', header: 'Account Type', width: '8' },
      { field: 'companyName', header: 'Company Name', width: '10' },
      { field: 'status', header: 'Status', width: '6' },
      { field: 'createDateTime', header: 'Create Date/Time', width: '10' },
      { field: 'noOfUsers', header: 'No. of Users', width: '8' },
      { field: 'contractType', header: 'Contract Type', width: '8' },
      { field: 'serviceAgreementAccepted', header: 'Agreement', width: '8' },
      { field: 'firstName', header: 'First Name', width: '10' },
      { field: 'lastName', header: 'Last Name', width: '10' },
      { field: 'email', header: 'Email Address', width: '13' },
      
    ];

    this.accountTypes = [
      Account.ACCOUNT_TYPE_STANDARD,
      Account.ACCOUNT_TYPE_NON_STANDARD,
      Account.ACCOUNT_TYPE_SERVICE_DESK,
      {label: 'None', value: ""}
    ];

    this.contractTypes = [Account.CONTRACT_TYPE_CLICK_THRU, Account.CONTRACT_TYPE_SIGNED, {label: 'None', value: ""}]

    this.accountStatuses = [
      Account.ACCOUNT_STATUS_PENDING,
      Account.ACCOUNT_STATUS_REJECTED,
      Account.ACCOUNT_STATUS_APPROVED,
      Account.ACCOUNT_STATUS_ACTIVE,
      Account.ACCOUNT_STATUS_INACTIVE
    ];

    this.selectedStatuses= [
      Account.ACCOUNT_STATUS_PENDING.value,
      Account.ACCOUNT_STATUS_REJECTED.value,
      Account.ACCOUNT_STATUS_APPROVED.value,
      Account.ACCOUNT_STATUS_ACTIVE.value,
    ];

    this.agreementTypes= [{label: 'Accepted', value: true}, {label: 'Not Accepted', value: false}]
  }


  // lifecycle to retrive table instance when all data from getAccounts is loaded, then set filters if any
  ngAfterViewInit() {
        this.changeDetector.detectChanges(); 
        this.aTable.changes.subscribe((comps: QueryList <Table>) => { 
          window.setTimeout(() => {
          this.tableForFilters = comps.first;
            if(!this.wereFiltersLoaded) {
              this.wereFiltersLoaded = true;
            this.getFilter();
            }
          }, 0);
        });

   }

  ngOnInit() {
    const authorizationToken = this.authService.getToken();

    this.getAccounts();

    //Init tiers
    this.feeScheduleService.getFeeScheduleList().subscribe(
      resp => {
        if (resp['status'] === 'fail') {
          // prepare error message
          const message: any = resp['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.log.error(`feeScheduleList(): errorMessage=${errorMessage}`);
        } else {
          var fees = resp['feeSchedule'] || null;

          if (fees === null) {
            this.log.error(`feeScheduleList(): fee schedule list is empty`);
          }
          else {
            this.tiers = fees.map(function(fee){
              return {label:fee.tierName.replace(/([^0-9])([0-9])/g, '$1 $2'), value:fee.tierName}; //Tier1 -> Tier 1
            });
            this.tiers.push({label:"Custom", value:"Custom"}); //For non-standard tiers
          }
        }
      },
      error => {
        this.log.error(`feeScheduleList(): got HttpError=${JSON.stringify(error)}`);
      }
    );

    // retrieve any filter and sort settings on p-table if any
    this.getSort();
  }

  sameAsAccountInfo(event) {

    this.sameAsAccount = event.checked;

    // if user wants billing same as contact information
    if(event.checked == true) {
      this.selectedAccountCopy.billingFirstName = this.selectedAccountCopy.firstName;
      this.selectedAccountCopy.billingLastName = this.selectedAccountCopy.lastName;
      this.selectedAccountCopy.billingEmail = this.selectedAccountCopy.email;
      this.selectedAccountCopy.billingPhone = this.selectedAccountCopy.phone;
      this.selectedAccountCopy.billingCountry = this.selectedAccountCopy.country;
      this.selectedAccountCopy.billingAddress1 = this.selectedAccountCopy.address1;
      this.selectedAccountCopy.billingAddress2 = this.selectedAccountCopy.address2;
      this.selectedAccountCopy.billingCity = this.selectedAccountCopy.city;
      this.selectedAccountCopy.billingState = this.selectedAccountCopy.state;
      this.selectedAccountCopy.billingZipCode = this.selectedAccountCopy.zipCode;
    }
  }

  clearFilter() {
    this.ptable.reset();
    this.filter.reset();
  }


  formatAccountData() {
    this.accounts.forEach((account) => {
      // TODO:
    });
  }


  /**
   * Detemine whether an account status can be changed or not
   * Status can be changed only when the existing status has a value of pending or rejected.
   */
  canChangeStatus(status: string): boolean {
    let rv = false;

    switch (status) {
      case 'approved':
      case 'pending':
      case 'rejected':
      case 'active':
      case 'inactive':
        rv = true;
        break;
      default:
        break;
    }

    return rv;
  }


  /**
   * when a row is selected
   * 1. if user has been working on a selected row, ignore the current selection
   * 2. otherwise enable the applicable action buttons.
   */
  onRowSelect($event) {
    this.isAccountSelected = true;
    if (this.isWorkingOnSelected) {
      // user is in the middle of working an account, so ignore this selection activity
    } else {
      // this.clearMessages();

      // setup edit account work env.
      this.editHandle.reset();
      this.editHandle.canEditAccount = true;

      if(this.selectedAccount.status === 'pending' )
        this.editHandle.canDeleteAccount = true;
      // setup change status work env.
      this.statusHandle.reset();
          
      if (this.canChangeStatus(this.selectedAccount.status)) {
        this.statusHandle.canChangeStatus = true;
        this.statusHandle.currentStatus = this.selectedAccount.status;
        this.statusHandle.changedStatus = this.selectedAccount.status;
      }
    }
  }


  /**
   * when selected row is unselected,
   * 1. if user is working on a selected row, ignore this unselection activity
   * 2. otherwise, disable the all action buttons.
   */
  onRowUnselect($event) {
    this.isAccountSelected = false;
    if (this.isWorkingOnSelected) {
      // user is in the middle of working an account, so ignore this unselection activity
    } else {
      this.editHandle.reset();
      this.statusHandle.reset();
    }
  }


  /**
   * show action section: Edit Account or Change Status
   * 1. set isWorkingOnSelected flag to true
   * 2. make deep copy of selected account
   * 3. disable action buttons
   * 4. activate the requestd action section
   */
  showArea(handle) {
    this.isWorkingOnSelected = true;
    this.selectedAccountCopy = JSON.parse(JSON.stringify(this.selectedAccount));

    this.editHandle.canEditAccount = false;
    this.editHandle.showArea = false;
    this.editHandle.canDeleteAccount = false;
    this.statusHandle.canChangeStatus = false;
    this.statusHandle.showArea = false;

    switch (handle) {
      case this.editHandle:
        handle.showArea = true;
        break;
      case this.statusHandle:
        handle.showArea = true;
        break;
      default:
        break;
    }
    this.changeDetector.detectChanges();
  }


  /**
   * display Change Status section
   */
  showEditAccountArea(): void {
    this.showArea(this.editHandle);
    this.scrollTop();
  }


  /**
   * display Change Status section
   */
  showChangeStatusArea(): void {
    this.showArea(this.statusHandle);
    this.scrollTop();
  }

  dialogClosed():void {
    this.scrollTop();
  }

  showDeleteDialog(): void {
    this.display = true;
  }

  ok(): void{
    this.statusHandle.changedStatus = 'deleted';
    this.saveChangedStatus();
    this.cancel();

  }

  cancel(): void{
    this.display = false;
    this.editHandle.reset();
    this.editHandle.canEditAccount = false;
    this.editHandle.canDeleteAccount = false;
    // setup change status work env.
    this.statusHandle.reset();
  }
  /*saveRuaList(ruaList:BaseRua[]){
    this.selectedAccount.ruaList = ruaList;
    this.selectedAccountCopy.ruaList = ruaList;
    this.numOfRua = this.getRuaDisplay();
    this.saveEditAccount(this.selectedAccount);
  }*/

  /**
   * save modified account
   */
  saveEditAccount(accountToSave) {
    this.clearMessages();
    this.isWorkingOnSelected = false;
    this.sameAsAccount = false;
    this.isAccountSelected = false;

    if (accountToSave)

    if (!this.hasDigitsAndLetters(this.selectedAccountCopy.spid, 4)) {
      this.displayErrorMessage(new Message('Error', 'The SPID must be 4 characters.'));
      return false;
    }
    
    if (this.selectedAccountCopy.accountType === Account.ACCOUNT_TYPE_STANDARD.value && 
      this.selectedAccountCopy.contractType === Account.CONTRACT_TYPE_SIGNED.value) {
        this.displayErrorMessage('Contract Type cannot be signed when the Account Type is standard.');
        return false;
      }

    // save the finalized account
    this.accountCompletionService.putAccountCompletion(JSON.stringify(accountToSave)).subscribe(
      res => {
        this.log.debug(`saveMyAccount(): result message=${JSON.stringify(res)}`);
        if (res['status'] === 'fail') { console.log(res);
          // failed to save the finalized account
          const message: any = res['messages'][0];
          const errorMessage = message['message'];

            if(message['code'] === 'TNF-1117') {
              this.displayErrorMessage("This email is already associated with an account. Please enter a different email address.", "Duplicate billing email address.");
              this.log.error(`failed to save the updated account: ${errorMessage}`);
            }
            else {
              this.log.error(`failed to save the updated account: ${errorMessage}`);
              this.displayErrorMessage(errorMessage);
            }
          
        } else {
          // upon successfully edit the account:
          // 1. display success message.
          // 2. refresh account table with the updated account info
          // 3. close the edit account section by resetting editHandle
          this.displaySuccessMessage(
            `Success`,
            `Account ${this.selectedAccount.accountId} has been updated.`);
          // successfully save the finalized account, navigate to /search page
          this.log.info(`saveEditAccount(): sucessfully updated account(${accountToSave.accountId})`);

          // refresh table with updated account
          this.updateTableAccount(res['account']);
          this.editHandle.reset();
          this.selectedAccount = null;
        }
      },
      error => {
        this.log.error(`failed to save the modified account: got HttpError=${JSON.stringify(error)}`);
        this.processHttpError(error);
      }
    );

  }


  /**
   * close Edit Account section
   */
  cancelEditAccount() {
    this.clearMessages();
    this.editHandle.reset();
    this.ptable.selection = null;
    this.isWorkingOnSelected = false;
    this.sameAsAccount = false;
    this.isAccountSelected = false;
  }


  /**
   * update table with updated account info
   * updatedAccount - updated Account returned
   */
  updateTableAccount(updatedAccount) {
    // locate the changed row in the accounts and replaced with changed account info
    // then slice the table data for display
    const BreakException = {};

    try {
      this.accounts.forEach((account, index) => {
        if (account.accountId === updatedAccount.accountId) {
          this.accounts[index] = updatedAccount;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) { throw e; }
    }

    // slice the accounts to trigger the change detection for refreshing table display
    this.accounts = this.accounts.slice();

  }


  /**
   * when status is changed, triger info message to be displayed
   */
  changeStatus(changedStatus: string) {
    this.log.debug(`changedStatus=${changedStatus}`);

    this.statusHandle.changedStatus = changedStatus;

    this.clearMessages();
    console.log("this.selectedAccountCopy.accountType: " + this.selectedAccountCopy.accountType)
    if(this.selectedAccountCopy.accountType === undefined || this.selectedAccountCopy.accountType === '') {
      this.displayErrorMessage(`You must choose an Account Type in the Edit Account section before changing the status of an account.`);
      return false;
    }

    if (this.statusHandle.changedStatus == 'inactive') {
      this.displayWarningMessage(new Message(
        `Account Status Change`,
        `You are about to change the status from ${this.statusHandle.currentStatus} to Inactive. This operation must be pre-approved by Bob since it cannot be undone.`));
      return true;
    }
    switch (`${this.statusHandle.currentStatus}-${this.statusHandle.changedStatus}`) {
      case 'pending-approved':
        this.displayWarningMessage(new Message(
          `Account Status Change`,
          `By changing the status from Pending to Approved,
          the first admin user of the account will be created
          and notified by email on how to access the system.`));
        break;
      case 'pending-rejected':
        this.displayWarningMessage(new Message(
          `Account Status Change`,
          `By changing the status from Pending to Rejected,
          the first admin user of the account will be notified by email
          that their account has not been approved.`));
        break;
      case 'rejected-approved':
        this.displayWarningMessage(new Message(
          `Account Status Change`,
          `By changing the status from Rejected to Approved,
          the first admin user of the account will be created
          and notified by email on how to access the system.`));
        break;
        
      default:
        break;
    }

   
  }
  isChangeStatusFormValid (currentStatus, changedStatus) {
   
    if (this.selectedAccountCopy.accountType === undefined || this.selectedAccountCopy.accountType === '')
        return false;

   /* if (currentStatus === changedStatus)  {
      return false;
    } */
    
    if (changedStatus === 'rejected') {
      if (this.selectedAccountCopy.reason !== undefined && this.selectedAccountCopy.reason !== '')
        return true;
      else
        return false;
    }
    

    if (changedStatus === 'inactive') {
           
      if (this.selectedAccountCopy.reason !== undefined && this.selectedAccountCopy.reason !== '' &&
        this.selectedAccountCopy.inactiveNotificationDate !== undefined &&  /(\d{4})-(\d{2})-(\d{2})/.test(this.selectedAccountCopy.inactiveNotificationDate) &&
        this.selectedAccountCopy.inactiveEffectiveDate !== undefined && /(\d{4})-(\d{2})-(\d{2})/.test(this.selectedAccountCopy.inactiveEffectiveDate)) {
        return true;
      } else
       return false;
    }
    
    return true;
  }

  isAccountFormValid(selectedAccountCopy) {
    //if (this.selectedAccountCopy)
    // console.log("this.selectedAccountCopy.custom.monthlyFee: " + this.selectedAccountCopy.custom.monthlyFee);
    const isStandardAccountValid = this.selectedAccountCopy.accountType === Account.ACCOUNT_TYPE_STANDARD.value && this.selectedAccountCopy.tier;

    this.isNonStandardAccountValid = false;
    if (this.selectedAccountCopy.accountType === Account.ACCOUNT_TYPE_NON_STANDARD.value) {
      if (this.selectedAccountCopy.custom !== undefined) {
        if (this.selectedAccountCopy.custom.monthlyFee !== ''  && this.selectedAccountCopy.custom.monthlyFee !== undefined &&
          this.selectedAccountCopy.custom.queryAllowance !== '' && this.selectedAccountCopy.custom.queryAllowance !== undefined &&
          this.selectedAccountCopy.custom.overageCharge !== '' && this.selectedAccountCopy.custom.overageCharge !== undefined) {
          this.isNonStandardAccountValid = true;
        }
      }
    }
   
             
      
      
   
      if (this.accountForm && this.selectedAccountCopy.accountType === Account.ACCOUNT_TYPE_NON_STANDARD.value) {
        return  this.accountForm.valid && (this.isNonStandardAccountValid);
      }

    if (this.accountForm && this.selectedAccountCopy.status === "active") {
      
      return this.accountForm.valid && (isStandardAccountValid );
    }
    else {
      
     // console.log("account: " + JSON.stringify(this.selectedAccountCopy));
    // else
    if (this.accountForm)
      return this.accountForm.valid ;
    else 
      return false;
    }
  }

  saveChangedStatus() {
    this.log.debug(`saveChangedStatus(): accountId=${this.selectedAccount.accountId}, changedStatus=${this.statusHandle.changedStatus}`);
    this.clearMessages();
    this.isWorkingOnSelected = false;
    if (this.selectedAccountCopy.reason === undefined)
      this.selectedAccountCopy.reason = '';

      if (this.selectedAccountCopy.inactiveNotificationDate === undefined)
      this.selectedAccountCopy.inactiveNotificationDate = null;

      if (this.selectedAccountCopy.inactiveEffectiveDate === undefined)
      this.selectedAccountCopy.inactiveEffectiveDate = null;

      if(this.selectedAccount.status !== this.statusHandle.changedStatus)
        this.selectedAccount.status = this.statusHandle.changedStatus

    this.serviceDeskService.postChangedStatus(
      this.selectedAccount.accountId,
      this.selectedAccount.status,
      this.selectedAccountCopy.reason,
      this.selectedAccountCopy.inactiveNotificationDate,
      this.selectedAccountCopy.inactiveEffectiveDate
    ).subscribe(
      res => {
        this.log.debug(`data=${JSON.stringify(res).substr(0, 2000)}`);

        if (res['status'] === 'fail') {
          // prepare error message
          this.isError = true;
          if(this.selectedAccount.status === 'deleted')
            this.selectedAccount.status = 'pending'

           const message: any = res['messages'][0];
          if (message['code'] != undefined) {
            const errorMessage = message['code'] + ' - ' + message['message'];
            this.log.error(`failed to change the status: ${errorMessage}`);
            this.displayErrorMessage(errorMessage);
          } else {
            const errorMessage = message['message'];
            this.log.error(`failed to change the status: ${errorMessage}`);
            this.displayErrorMessage(errorMessage);
          }


        } else {
          // upon successfully changing the status:
          // 1. display success message.
          // 2. refresh account table with the changed status
          // 3. close the Change Status section by resetting statusHandle
          this.displaySuccessMessage(
            `Success`,
            `Status for account ${this.selectedAccount.accountId} has been changed.`);
          this.isError = false;
          this.updateTableStatus();
         // this.updateTableAccount(res['account']);
          //this.selectedAccount = null;
          this.statusHandle.reset();
          this.ptable.selection = null;
          this.display = false;
          this.selectedAccount.status=null;
          this.getAccounts();  
          
        }
      },
      error => {
        this.processHttpError(error);
      }
    );
  }

  getAccounts() {
    this.serviceDeskService.getAccountList(this.authService.getToken()).subscribe(
      res => { 
        this.log.debug(`data=${JSON.stringify(res).substr(0, 1000)}`);
        this.log.debug(`message=${JSON.stringify(res['messages'])}`);

        if (res['status'] === 'fail') {
          this.accounts = null;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
        } else {

          this.filteredAccounts = res['Accounts'];
          if (this.filteredAccounts.length === 0) {
            this.accounts = null;
          } else {
           this.accounts = this.filteredAccounts.filter(account => account.status !== "deleted");
            this.formatAccountData();
           // this.ptable.value = this.accounts;
           

          }  
          // this.log.debug(`this.accounts=${JSON.stringify(this.accounts)}`);
        }

      }, 
      error => {
        this.processHttpError(error);
      }  
    );

  }

  /**
   * close Change Status section
   */
  cancelChangedStatus() {
    this.clearMessages();
    this.statusHandle.reset();
    this.ptable.selection = null;
    this.isWorkingOnSelected = false;
  }


  /**
   * reflect successfully changed status in the table
   */
  updateTableStatus() {
    // localte the changed row in the accounts and update it with the changed status
    // then slice the table data for display
    const BreakException = {};

    try {
      this.accounts.forEach((account) => {
        if (account.accountId === this.selectedAccount.accountId) {
          account.status = this.statusHandle.changedStatus;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) { throw e; }
    }

    // slice the accounts to trigger the change detection for refreshing table display
    this.accounts = this.accounts.slice();

  }


  /**
   * generate RUA display string
   */
  /*getRuaDisplay():string {
    const numOfRua = this.selectedAccount && this.selectedAccount.ruaList && this.selectedAccount.ruaList.length || 0;

    return numOfRua > 1
      ? numOfRua + ' Regional User Agreements'
      : numOfRua + ' Regional User Agreement';
  }

  showRuaDialog() {
    this.ruaDialog.show();
  }*/

  onCustomTierChange(customTier:Tier){
    this.selectedAccountCopy.custom = customTier;
    this.selectedAccountCopy.tier = "Custom";
    
  }

  updateTierChange(tier) {
    this.selectedAccountCopy.tier = tier;
  }

  /**
   * user changed filters
   * @param event
   */
  onFilter(event) { 
    // set filter settings in users sessionstorage for later retrieve upon component load
    sessionStorage.setItem('filterSettings', JSON.stringify(this.filter));
    // filtering will change the pagination, so let's reset the index 'first'
    this.first = 0;
    this.log.debug(`first=${this.first}`);
    
    
  }


  /**
   * user changed pagination
   * @param event
   */
  onPage(event) {
    this.first = event.first;
    this.ptable.rows = event.rows;

    this.log.debug(`first=${this.first}, rows=${this.ptable.rows}`);
  }


  /**
   * user changed sort order
   */
  onSort(event) { 
    // save the current sort in sessionstorage
    this.sortFieldTable.accountId = event.field;
    this.sortFieldTable.order = event.order;
    sessionStorage.setItem('sortSettings', JSON.stringify(this.sortFieldTable));
    // sorting will change the pagination, so let's reset the index 'first'
    this.first = 0;
    this.log.debug(`first=${this.first}`);
  }

  // method to retrieve sort settings upon ngInit
  getSort() {
    if (sessionStorage.getItem("sortSettings") === null) {
      this.sortFieldTable.accountId = "accountId";
      this.sortFieldTable.order = -1;
    }
    else {
      this.sortFieldTable = JSON.parse(sessionStorage.getItem("sortSettings"));
    }
  }

  // method to retrieve filter settings, if any, then call Table method to filter p-table
  getFilter() {
    
    if (sessionStorage.getItem("filterSettings") != null) {
      this.filter = JSON.parse(sessionStorage.getItem("filterSettings"));
    }

    if (Object.keys(this.filter).length != 0) {
      for (let x in this.filter) {

        if (this.filter[x] !== "" && (x == "companyName" || x == "companyName" || x == "firstName" || x == "lastName")) {
        this.tableForFilters.filters[x] = {value: this.filter[x], matchMode: "startsWith"};
        }
        else if (this.filter[x].length !=0 && (x == "accountType" || x == "status" || x == "contractType" || x == "serviceAgreementAccepted")) {
          this.tableForFilters.filters[x] = {value: this.filter[x], matchMode: "in"};
        }
        else if (this.filter[x] !== "" && x == "email") {
          this.tableForFilters.filters[x] = {value: this.filter[x], matchMode: "contains"};
        }
      }
      this.tableForFilters._filter();
    }
    // if no filters were previously set, set these default filters
    else {
      if (Object.keys(this.filter).length == 0) {
        let statusFilterToStart =  ['approved', 'rejected', 'pending', 'active'];
        this.filter['status'] = [];
        for (let i = 0; i<statusFilterToStart.length; i++) {
          this.filter['status'].push(statusFilterToStart[i]);
        }
        this.tableForFilters.filters['status'] = {value: this.filter['status'], matchMode: "in"};
        this.tableForFilters._filter();
      }

    } 
  }

  /**
   * Scroll to the top of the page.
   */
  scrollTop() {
    window.scrollTo(0, 0);
  }

  /**
   * Is the element provided as the argument scrolled into view.
   * @param elem element to check viewability of.
   */
  isScrolledIntoView(elem): boolean {
    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();

    const elemTop = $(elem).offset().top;
    const elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }


  /**
   * Anytime the window is scrolled, this is called.  It checks
   * to see if the home button should be made visible at the bottom
   * of the page.
   */
  onScroll(e: any) {
    this.showHome = !this.isScrolledIntoView($('#can-you-see-me-now'));
  }

  getAccepted(accepted: boolean): string {
    console.log("Accepted: " + accepted);
    if (accepted == true) {
      return 'Accepted';
    } else {
      return 'Not Accepted';
    }
  }

  hasDigitsAndLetters(string: string, n: number): boolean {

    if (string === null || string === '') {
      return true;
    } else { //non(alphanumeric + _ )
      return string.replace(/[\W_]/g, '').length === n;
    }
  }



}

